export default "__VITE_ASSET__DjuOhbMA__"